import { PlatformLocation } from "@angular/common";
import { AfterContentChecked, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { NavigationStart, Router } from "@angular/router";
import { ThemeManager } from "@coso/layout";
import "@coso/layout/external-dependencies";
import { AuthService } from "@coso/saas-angular";
import { RuntimeSettingsService } from "@coso/utility";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import $ from "jquery";
import { Observable } from "rxjs";
import { ReplicatorUiSettings } from "./models/replicator-ui-settings";
import { ScheduleDowntimeService } from "./services/schedule-downtime.service";
import { IReplicatorScheduleDowntime } from "@coso-replicator/core";

@Component({
  standalone:false,
  selector: "coso-replicator-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit, AfterContentChecked {
  uiAppSettings: ReplicatorUiSettings;
  tenantName$: Observable<string>;
  tenantId$: Observable<string>;
  username$: Observable<string>;
  isAuthenticated$: Observable<boolean>;
  isDoneLoading$: Observable<boolean>;
  scheduledDowntime$: Observable<IReplicatorScheduleDowntime>;
  scheduledDowntimeService : ScheduleDowntimeService;
  ThemeManager = ThemeManager;
  getAccessToken = () => this.authService.getAccessToken();

  constructor(
    public router: Router,
    configSvc: RuntimeSettingsService,
    public domSanitizer: DomSanitizer,
    public authService: AuthService,
    private cdRef: ChangeDetectorRef,
    ngbModalService: NgbModal,
    platformLocation: PlatformLocation,
    private scheduleDowntimeService : ScheduleDowntimeService
  ) {
    this.uiAppSettings = configSvc.configObject as ReplicatorUiSettings;
    this.isAuthenticated$ = this.authService.isAuthenticated$;
    this.isDoneLoading$ = this.authService.isDoneLoading$;
    this.username$ = this.authService.username$;
    this.tenantName$ = this.authService.tenantName$;
    this.tenantId$ = this.authService.tenantId$;
    this.scheduledDowntimeService = scheduleDowntimeService;
    platformLocation.onPopState(() => ngbModalService.dismissAll());
  }

  async ngOnInit() {
    if (this.uiAppSettings.isMaintenance) {
      ThemeManager.instance.initialize();
      this.removeProgressIndicator();
    }
    await this.authService.runInitialLoginSequence();
    document.addEventListener("click", () => {
      $(".tooltip").tooltip("dispose");
      $(".popover").popover("dispose");
    });
    this.scheduledDowntime$ = this.scheduleDowntimeService.getScheduleDownTimeAsync();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        $('[data-toggle="tooltip"]').tooltip("dispose");
        $('[data-toggle="popover"]').popover("dispose");
      }
    });
  }

  ngAfterContentChecked() {
    $('[data-toggle="tooltip"]').tooltip({
      container: "body",
      boundary: "window"
    });

    $('[data-toggle="popover"]').popover({
      container: "body",
      boundary: "window"
    });
  }

  showLayout() {
    const layoutElement: HTMLCosoLayoutElement = document.querySelector("coso-layout");
    this.removeProgressIndicator();
    layoutElement.className = "visible";
  }

  logout() {
    this.router.navigateByUrl("logout");
  }

  onRouteActivated() {
    // Call OnInit of routed component
    this.cdRef.detectChanges();
  }

  private removeProgressIndicator() {
    const container = document.getElementById("site");
    const loadingElement = document.querySelector(".loading-progress");
    container.removeChild(loadingElement);
  }
}
